import { InviteCategory } from '@/domain/external-invitation/entities/invitation-category';
import { Sector } from '@/domain/impact/impact.entity';

import { CategoriesBySectorByMode, Mode } from './categories-types';
import { CATEGORIES_FESTIVAL } from './data/categories-festival';
import { CATEGORIES_VENUE_DATE } from './data/categories-venue-date';
import { CATEGORIES_VENUE_STRUCTURE } from './data/categories-venue-structure';

const CATEGORIES: CategoriesBySectorByMode = {
  festival: CATEGORIES_FESTIVAL,
  'venue-structure': CATEGORIES_VENUE_STRUCTURE,
  'venue-date': CATEGORIES_VENUE_DATE,
};

export function getCategories(
  mode: Mode,
  sector: Sector,
): InviteCategory[] | undefined {
  return CATEGORIES[mode][sector];
}
